import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import client, { apiError } from "../api/client";
import { Loader2 } from "lucide-react";

const PIXEL_BG =
  "https://static.prod-images.emergentagent.com/jobs/0098af78-0bcd-4c29-9ef3-e924547f96fd/images/5a1d79fa149ee3d3f8a945fa8e3dc1053f7d28b24489464cf8667edbc0a51392.jpeg";
const FALLBACK = ["Lucka to zvládne. My taky."];

export default function Login() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [loginId, setLoginId] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const [hlaska, setHlaska] = useState("");

  useEffect(() => {
    client
      .get("/login-messages")
      .then((res) => {
        const msgs = res.data && res.data.length ? res.data : FALLBACK;
        setHlaska(msgs[Math.floor(Math.random() * msgs.length)]);
      })
      .catch(() => setHlaska(FALLBACK[0]));
  }, []);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      const u = await login(loginId.trim(), password);
      navigate(u.role === "lector" ? "/lector/dashboard" : u.role === "admin" ? "/dashboard" : "/workshops", {
        replace: true,
      });
    } catch (err) {
      setError(apiError(err, "Přihlášení se nezdařilo"));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen grid lg:grid-cols-2">
      <div className="hidden lg:flex relative overflow-hidden bg-[#0b1020]">
        <img
          src={PIXEL_BG}
          alt=""
          className="absolute inset-0 h-full w-full object-contain"
          style={{ imageRendering: "pixelated" }}
        />
        <div className="absolute inset-0 bg-gradient-to-t from-[#0b1020] via-[#0b1020]/50 to-transparent" />
        <div className="relative mt-auto p-10 w-full">
          <div className="font-heading text-2xl font-semibold tracking-tight text-white/90 mb-3">Lucka</div>
          <p data-testid="easter-egg" className="text-white text-2xl leading-snug font-heading max-w-md">
            {hlaska}
          </p>
        </div>
      </div>

      <div className="flex items-center justify-center p-8">
        <form onSubmit={submit} className="w-full max-w-sm" data-testid="login-form">
          <h1 className="font-heading text-2xl font-semibold tracking-tight">Přihlášení</h1>
          <p className="text-sm text-muted-foreground mt-1 mb-8">Zadejte své přihlašovací údaje.</p>

          <label className="block text-xs uppercase tracking-widest font-medium text-muted-foreground mb-1.5">
            Uživatel / e-mail
          </label>
          <input
            data-testid="login-input"
            value={loginId}
            onChange={(e) => setLoginId(e.target.value)}
            className="w-full h-11 px-3 rounded-md border border-input bg-background text-sm mb-4 outline-none focus:ring-2 focus:ring-ring/20 focus:border-ring transition-colors"
            autoFocus
          />

          <label className="block text-xs uppercase tracking-widest font-medium text-muted-foreground mb-1.5">
            Heslo
          </label>
          <input
            data-testid="password-input"
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            className="w-full h-11 px-3 rounded-md border border-input bg-background text-sm mb-4 outline-none focus:ring-2 focus:ring-ring/20 focus:border-ring transition-colors"
          />

          {error && (
            <div data-testid="login-error" className="text-sm text-destructive mb-4">
              {error}
            </div>
          )}

          <button
            data-testid="login-submit"
            type="submit"
            disabled={loading}
            className="w-full h-11 rounded-md bg-primary text-primary-foreground text-sm font-medium hover:bg-primary/90 transition-colors disabled:opacity-60 flex items-center justify-center gap-2"
          >
            {loading && <Loader2 className="h-4 w-4 animate-spin" />}
            Přihlásit se
          </button>
        </form>
      </div>
    </div>
  );
}
